import React from 'react';
import { Box, CircularProgress } from '@material-ui/core';

export interface BaseGqlComponentProps<TVariables> {
    redirectOnErrorUrl?: string;
    Loader?: React.ComponentType;
}

export const LoaderElement = () => (
    <Box p={1}>
        <CircularProgress />
    </Box>
);
